import axios from '@/axios'
import gateway from '@/gateway'
import Raven from 'raven-js'
import Vue from 'vue'
import heap from '@frontend/heap'

class Login {
  public axios = axios
  public user: any = null
  // TODO:
  public iframe: HTMLIFrameElement | HTMLElement | null
  public com: any
  public ghosted = false
  public events = new Vue()
  public token: string | null

  constructor () {
    this.token = null
    this.user = null

    const interceptor = (config) => {
      config.headers.common.Authorization = 'Bearer ' + this.getToken()
      return config
    }

    this.axios.interceptors.request.use(interceptor)
    gateway.interceptors.request.use(interceptor)
  }

  init() {
    this.token = localStorage.getItem('token')
  }

  is() {
    return !!this.getToken()
  }

  getToken() {
    return this.token
  }

  setToken(token, keep = false) {
    this.token = token
    if (keep) {
      localStorage.setItem('token', token)
    }
  }

  getUser() {
    return this.user
  }

  isEditor() {
    return (
      this.user.permissions.filter(({ name }) => name === 'articles.view')
        .length === 1
    )
  }

  setUser(user) {
    if (
      user.permissions.find(({ name }) => name === 'admin.login') === undefined
    ) {
      this.logout()
      return
    }

    if (user.token.name === 'Ghost') {
      this.ghosted = true
      user.updated_admin_gdpr_at = true
    }
    this.user = user
    heap.setupTracking(user)

    if (process.env.NODE_ENV === 'production') {
      Raven.setUserContext({
        email: user.email,
        id: user.id,
      })
    }
    this.events.$emit('logged-in')
  }

  logout () {
    localStorage.removeItem('token')
    this.token = null

    if (window.heap) {
      heap.resetTracking()
    }

    if (process.env.NODE_ENV === 'production') {
      Raven.setUserContext()
    }

    this.events.$emit('logged-out')

  }

  can (permission) {
    const perm = this.getPermission(permission)
    if (permission == 'analytics.channel') {
      return !!perm && !!this.getChannel()
    } else {
      return !!perm
    }
  }

  getPermission (permission) {
    return this.user.permissions.find(({name}) => name === permission)
  }

  canAnalytics () {
    return this.can('analytics.network') || this.can('analytics.channel')
  }

  isINTL() {
    return this.user && this.user.account && this.user.account.id == 1156 && this.user.account.name.includes("INTL")
  }

  canAnalyticsINTL() {
    return this.can('analytics.network') && this.isINTL()
  }

  getChannel () {
    return this.user.channels.length > 0 ? this.user.channels[0] : null
  }

  getChannelName () {
    const channel = this.getChannel()

    return channel ? channel.name : 'Channel'
  }

  channelScopeId () {
    if (this.user.analyst) {
      return this.user.analyst.channel_id
    }
    const channel = this.getChannel()

    return channel ? channel.id : null
  }
}

let login
export default login = login || new Login
